export default __webpack_public_path__ + "static/media/kids-donate.d8cf195c.jpg";